'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface SortOption {
  label: string;
  value: string;
}

interface SortControlsProps {
  onSortChange: (sortBy: string) => void;
  resultCount: number;
}

const SortControls = ({ onSortChange, resultCount }: SortControlsProps) => {
  const [selectedSort, setSelectedSort] = useState('newest');
  const [isHydrated, setIsHydrated] = useState(false);

  React.useEffect(() => {
    setIsHydrated(true);
  }, []);

  const sortOptions: SortOption[] = [
    { label: 'Newest First', value: 'newest' },
    { label: 'Price: Low to High', value: 'price-asc' },
    { label: 'Price: High to Low', value: 'price-desc' },
    { label: 'Age: Youngest', value: 'age-asc' },
    { label: 'Age: Oldest', value: 'age-desc' },
    { label: 'Name: A-Z', value: 'name-asc' },
  ];

  const handleSortChange = (value: string) => {
    setSelectedSort(value);
    onSortChange(value);
  };

  if (!isHydrated) {
    return (
      <div className="flex items-center justify-between">
        <div className="h-6 w-32 rounded bg-muted" />
        <div className="h-10 w-48 rounded-md bg-muted" />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Icon name="ViewColumnsIcon" size={20} variant="outline" />
        <span>
          Showing <span className="font-semibold text-foreground">{resultCount}</span> {resultCount === 1 ? 'puppy' : 'puppies'}
        </span>
      </div>

      <div className="flex items-center gap-3">
        <label htmlFor="sort-select" className="text-sm font-medium text-foreground">
          Sort by:
        </label>
        <select
          id="sort-select"
          value={selectedSort}
          onChange={(e) => handleSortChange(e.target.value)}
          className="rounded-md border border-border bg-input px-4 py-2 text-sm text-foreground transition-smooth hover:border-primary/30 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
        >
          {sortOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default SortControls;